{
  "b2cTenant": "https://ixicoprod.b2clogin.com/ixicoprod.onmicrosoft.com",
  "adb2cSignInPolicy": "B2C_1A_V1_MfaChoiceSignIn",
  "adb2cFormCompletionPolicy": "B2C_1A_V1_MfaFormCompletion",
  "clientId": "d98ed4b1-43b6-42bc-ba81-6a0d4e13bf4e",
  "knownAuthorities": ["ixicoprod.b2clogin.com"],
  "redirectUri": "https://ttnx.ixico.com/",
  "postLogoutRedirectUri": "https://ttnx.ixico.com/",
  "navigateToLoginRequestUrl": true
}
